import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import styles from './ScoreItem.module.scss';

interface IScoreItemProps {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  title: string;
  value: string;
  loading: boolean;
}

const ScoreItem: React.FC<IScoreItemProps> = ({
  Icon,
  title,
  value,
  loading,
}) => {
  if (loading)
    return (
      <Skeleton
        className="flex grow basis-[15%] mr-[3.75rem] mb-[3rem]"
        height="13rem"
      />
    );

  return (
    <div className={styles.container}>
      <Icon className={styles.icon} />
      <span className={styles.title}>{title}</span>
      <span className={styles.value}>{value}</span>
    </div>
  );
};

export default ScoreItem;
